import React from 'react'
import PropTypes from 'prop-types'
import isString from 'lodash/isString'
import FormInputNumber from 'components/forms/FormInputNumber'
import FormCheckbox from 'components/forms/bases/FormCheckbox'

const FormSize = ({
  label,
  value,
  onChange,
}) => {
  return (
    <div>
      <FormInputNumber
        label={label}
        value={isString(value) ? '' : value}
        onChange={onChange}
        style={{ width: 'initial' }}
      />
      <FormCheckbox
        label="100%"
        value={value === '100%'}
        onChange={(val) => onChange(val ? '100%' : '')}
        style={{ width: 'initial', display: 'inline-block' }}
      />
    </div>
  )
}

FormSize.propTypes = {}
FormSize.defaultProps = {}

export default FormSize



// WEBPACK FOOTER //
// ./src/components/forms/FormSize.js